import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { HiOutlineMail, HiArrowLeft } from 'react-icons/hi';
import { authAPI, systemAPI } from '../services/api';
import { getErrorMessage } from '../utils/errorHandler';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { IOSButton } from '../components/ios';

function MobileForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [version, setVersion] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await systemAPI.getVersion();
        setVersion(response.data.version);
      } catch (error) {
        setVersion('1.4.1');
      }
    };

    fetchVersion();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error(t('auth.enterEmail'));
      return;
    }

    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setEmailSent(true);
      toast.success(t('auth.emailSentIfRegistered'));
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Tela de sucesso após enviar email
  if (emailSent) {
    return (
      <div className="mobile-auth-page">
        {/* Header */}
        <div className="mobile-auth-header">
          <div className="mobile-auth-back">
            <button onClick={() => navigate('/login')} className="mobile-auth-back-btn">
              <HiArrowLeft />
            </button>
          </div>
          <h1>My Series</h1>
          <p>{t('auth.forgotPasswordTitle')}</p>
        </div>

        {/* Conteúdo de sucesso */}
        <div className="mobile-auth-form">
          <div className="mobile-auth-success">
            <div className="mobile-auth-icon-large" style={{ background: 'var(--success-bg)', color: 'var(--success)' }}>
              <HiOutlineMail />
            </div>
            <h3>{t('auth.emailSent')}</h3>
            <p>
              {t('auth.checkEmailInstructions', { email })}
            </p>
          </div>

          <IOSButton
            variant="primary"
            fullWidth
            onClick={() => navigate('/login')}
            className="mobile-auth-submit"
          >
            {t('auth.backToLogin')}
          </IOSButton>
        </div>

        {/* Versão */}
        <div className="mobile-auth-version">
          <p>{t('auth.copyright')}</p>
          <p>{t('common.version')} {version}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mobile-auth-page">
      {/* Header com botão voltar */}
      <div className="mobile-auth-header">
        <div className="mobile-auth-back">
          <button onClick={() => navigate('/login')} className="mobile-auth-back-btn">
            <HiArrowLeft />
          </button>
        </div>
        <h1>My Series</h1>
        <p>{t('auth.forgotPasswordTitle')}</p>
      </div>

      {/* Descrição */}
      <div className="mobile-auth-info">
        <p>{t('auth.forgotPasswordDescription')}</p>
      </div>

      {/* Formulário */}
      <form className="mobile-auth-form" onSubmit={handleSubmit}>
        <div className="mobile-auth-field">
          <label>{t('common.email')}</label>
          <div className="mobile-auth-input-wrapper">
            <HiOutlineMail className="mobile-auth-icon" />
            <input
              type="email"
              placeholder={t('auth.enterRegisteredEmail')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              autoFocus
            />
          </div>
        </div>

        <IOSButton
          type="submit"
          variant="primary"
          fullWidth
          disabled={loading}
          className="mobile-auth-submit"
        >
          {loading ? t('auth.sending') : t('auth.sendInstructions')}
        </IOSButton>

        <div className="mobile-auth-footer">
          <Link to="/login" className="mobile-auth-link-primary">
            {t('auth.backToLogin')}
          </Link>
        </div>
      </form>

      {/* Versão */}
      <div className="mobile-auth-version">
        <p>{t('auth.copyright')}</p>
        <p>{t('common.version')} {version}</p>
      </div>
    </div>
  );
}

export default MobileForgotPassword;
